export const MaterialReturnRouting = [
  {
    path: "/material/materialReturn/list",
    name: "material-return-list",
    meta: { title: "项目退料申请" },
    component: () => import("@/views/material/material-return/list/index.vue"),
  },
  {
    hidden: true,
    path: "/material/materialReturn/create",
    name: "material-return-create",
    meta: { title: "新增项目退料申请", comName: "MaterialMaterialReturnFormCreate" },
    component: () => import("@/views/material/material-return/form-create/index.vue"),
  },
  {
    hidden: true,
    path: "/material/materialReturn/edit/:id",
    name: "material-return-edit",
    meta: { title: "编辑项目退料申请", comName: "MaterialMaterialReturnFormCreate" },
    component: () => import("@/views/material/material-return/form-create/index.vue"),
  },
  {
    hidden: true,
    path: "/material/materialReturn/detail/:id",
    name: "material-return-detail",
    meta: { title: "项目退料申请详情" },
    component: () => import("@/views/material/material-return/form-detail/index.vue"),
  },
  {
    hidden: true,
    path: "/material/materialReturn/flowPrint/:id",
    name: "material-material-return-flowPrint",
    meta: { title: "打印详情" },
    component: () =>
      import(
        /* webpackChunkName: "tender-quote" */ "@/views/material/material-return/flow-print/index.vue"
      ),
  },
];
